import React from 'react';
import { useForm } from 'react-hook-form';
import styles from './index.module.scss';
import DraggableDialog from '@components-clean/core/draggable-dialog';
import { TextBoxController } from '@components-clean/core/text-box';
import { useTranslation } from '@hooks/index';

const HEIGHT = 190;
const WIDTH = 450;

type Props = {
    reviewTitle: string;
    onCancel: () => void;
    onConfirm: () => unknown;
};

const ConfirmCloseReviewDialog = ({ reviewTitle, onCancel, onConfirm }: Props) => {
    const { t } = useTranslation('sm', { keyPrefix: 'monitoringToolkit.activeReviewTab.confirmCloseReviewDialog' });

    const {
        control,
        formState: { isValid },
    } = useForm({
        mode: 'all',
        defaultValues: {
            title: '',
        },
    });

    return (
        <DraggableDialog
            dataTestId="active-review-tab-close-review-dialog"
            width={WIDTH}
            height={HEIGHT}
            title={t('title')}
            onClose={onCancel}
            onSubmit={onConfirm}
            primaryBtnDisabled={!isValid}
        >
            <div className={styles.closeReviewDialogBody}>
                <p>{t('reviewCannotBeReopened')}</p>

                <TextBoxController
                    data-testid="close-review-dialog-text-input"
                    control={control}
                    name="title"
                    label={reviewTitle}
                    validateRules={{
                        correctTitle: (value) => {
                            if (value === reviewTitle) {
                                return true;
                            }
                            return t('validation.textDoesNotMatchTitle');
                        },
                    }}
                />
            </div>
        </DraggableDialog>
    );
};

export default ConfirmCloseReviewDialog;
